import * as React from "react";
import { useLocalization } from "@shared-ui/localization-context";
import { logger } from "bernie-core";
import { Viewport, ViewSmall, ViewMedium } from "bernie-view";
import { IsomorphicCarousel } from "components/shared/IsomorphicCarousel/IsomorphicCarousel";
import { ItemKeyHelper } from "components/utility/ItemKeyHelper";

import { UitkSpacing } from "uitk-react-spacing";
import { UitkLayoutFlex } from "uitk-react-layout-flex";
import { UitkCard, UitkCardContentSection } from "uitk-react-cards";

import { MobileConfidenceMessagesCarouselRegionProps } from "./typings";
import { hasRenderableChilren } from "src/components/flexFramework/FlexTemplateNode";
import { withStores } from "stores";

class MobileConfidenceMessagesCarouselRegion extends React.Component<MobileConfidenceMessagesCarouselRegionProps> {
  public render() {
    return <MobileConfidenceMessagesCarouseComponent {...this.props} />;
  }
}

const MobileConfidenceMessagesCarouseComponent = (props: MobileConfidenceMessagesCarouselRegionProps) => {
  const { context, blossomComponent, flexModuleModelStore, flexTemplateNode, l10n } = props;
  const { formatText } = useLocalization();

  if (!blossomComponent || !flexTemplateNode || !hasRenderableChilren(flexTemplateNode, flexModuleModelStore)) {
    return null;
  }

  const { id: flexComponentId } = flexTemplateNode;

  const children = blossomComponent.renderChildren(props.logger, l10n, context);

  const keyHelper = new ItemKeyHelper(flexComponentId);

  return (
    <div id={flexComponentId} className="MobileConfidenceMessagesCarouselRegion">
      <Viewport>
        <ViewSmall>
          <UitkSpacing margin={{ blockstart: "three", inlinestart: "three" }}>
            <IsomorphicCarousel
              itemsVisible={{ sm: 1, md: 1, lg: 2 }}
              buttonText={{
                nextButton: formatText("carousel.item.next"),
                prevButton: formatText("carousel.item.prev"),
              }}
              pageBy={1}
              peekWidth={20}
              wrapItems={false}
            >
              {children.map((child) => (
                <UitkCard key={keyHelper.next()}>
                  <UitkSpacing padding={{ inline: "two" }}>
                    <UitkLayoutFlex alignItems="center" tag="li">
                      <UitkCardContentSection padded={false}>{child}</UitkCardContentSection>
                    </UitkLayoutFlex>
                  </UitkSpacing>
                </UitkCard>
              ))}
            </IsomorphicCarousel>
          </UitkSpacing>
        </ViewSmall>
        <ViewMedium>
          <div className="desktopViewContainer">
            <UitkSpacing padding={{ inline: "one" }}>
              <UitkLayoutFlex space="four" className="desktopViewSubContainer">
                {children}
              </UitkLayoutFlex>
            </UitkSpacing>
          </div>
        </ViewMedium>
      </Viewport>
    </div>
  );
};

export default logger("MobileConfidenceMessagesCarouselRegion")(
  withStores("context", "flexModuleModelStore")(MobileConfidenceMessagesCarouselRegion)
);
